import * as React from 'react';

export type TIconProps = {
  src?: string; // Optional icon URL for the mask
  className?: string; // Optional className to allow custom styles
  skipAutoSize?: boolean;
  part?: string;
};

const Icon: React.FC<TIconProps> = ({ src: iconUrl, className, skipAutoSize = false, part = '' }) => {
  const [size, setSize] = React.useState<{ width?: string; height?: string }>({ width: undefined, height: undefined });

  // Effect to load the icon and set the width and height of the span
  React.useEffect(() => {
    if (!skipAutoSize && iconUrl) {
      const img = new Image();
      img.src = iconUrl;
      img.onload = () => {
        setSize({ width: `${img.width}px`, height: `${img.height}px` });
      };
    }
  }, [iconUrl, skipAutoSize]);

  return (
    <span
      role="img"
      aria-label="icon"
      part={`icon ${part}`}
      className={`ex3d-icon ${className}`}
      style={{
        maskImage: iconUrl ? `url(${iconUrl})` : undefined,
        width: size.width,
        height: size.height,
      }}
    />
  );
};

export default Icon;
